import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            {/* Redirect root to /en */}
            <Route path="/" element={<Navigate to="/en" replace />} />
            
            {/* Language routes */}
            <Route path="/en" element={<Home />} />
            <Route path="/fr" element={<Home />} />
            <Route path="/es" element={<Home />} />
            
            {/* Catch all - redirect to /en */}
            <Route path="*" element={<Navigate to="/en" replace />} />
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
